import ApiService from './api.service';

export default class Skeletons {
  static async fetchSkeletonsTypes(params) {
    const skeletons = await ApiService.get('/resources/skeletons', {
      params,
    });

    return skeletons;
  }

  static async findSkeletonType(skeletonId) {
    return ApiService.get(`/resources/skeletons/${skeletonId}`);
  }

  static async deleteSkeletonType(skeletonId) {
    return ApiService.delete(`/resources/skeletons/${skeletonId}`);
  }

  static async createSkeletonType(skeleton) {
    return ApiService.post('/resources/skeletons', skeleton);
  }

  static async updateSkeletonType(skeleton) {
    const { id } = skeleton;
    delete skeleton.id;

    return ApiService.put(`/resources/skeletons/${id}`, skeleton);
  }
}
